import { Box, CircularProgress, Typography } from "@mui/material";

type LoadingIndicatorProps = {
  compact?: boolean;
  label: string;
};

const LoadingIndicator = ({
  compact = false,
  label,
}: LoadingIndicatorProps) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: theme => theme.spacing(compact ? 1 : 1.5),
    }}
  >
    <CircularProgress
      size={compact ? 24 : 40}
      aria-label={label}
      color="primary"
    />
    <Typography
      variant="body2"
      sx={{
        color: "text.secondary",
      }}
    >
      {label}
    </Typography>
  </Box>
);

export default LoadingIndicator;
